<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6 d-none d-lg-block p-0">
                <img src="assets/images/form-images/form-side-banner.png" alt="form image" class="form-img">
            </div>
            <div class="col-sm-12 col-lg-6">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</section>